// A hard navigation cancels any request still in flight, so an event fired
// immediately before one is usually lost. Waiting for delivery fixes that but
// puts analytics on the critical path of a user action, so the wait is capped:
// analytics may delay a navigation, never prevent it.
const DELIVERY_BUDGET_MS = 500

export async function trackBeforeNavigating(
  delivery: Promise<unknown> | undefined,
  navigate: () => void,
): Promise<void> {
  await Promise.race([
    // A failed delivery must never surface in the caller's click handler — the
    // navigation has to happen either way. Promise.resolve also tolerates a
    // `track` that returns nothing, so a stubbed one can't break checkout.
    Promise.resolve(delivery).catch(() => undefined),
    new Promise((resolve) => setTimeout(resolve, DELIVERY_BUDGET_MS)),
  ])

  navigate()
}
